<!--
 * @Desc: 学校概况
 * @Author: 赵佳明
 * @Date: 2023-01-30 09:11:04
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-06-08 14:53:35
 * Copyright (c) 2023 山木枝(河北)技术服务有限公司, All Rights Reserved. 
-->
<template>
    <div class="school-profile">
        <div class="container">
            <div class="title-hold">
                <div class="title">
                    <img
                        class="pic"
                        src="../../../public/statics/images/Index/SchoolProfile-title.png"
                    />
                </div>
                <div class="title-more" @click="toMore()">
                    了解更多
                    <img class="thu" src="../../../public/statics/images/arr.png">
                </div>
            </div>
            <section class="swiper swiper-profile">
                <div class="swiper-wrapper" v-if="listData && listData.article">
                    <div class="swiper-slide" v-for="(item,idx) in listData.article" :key="idx" @click="toDetail(item)">
                        <!-- <div class="slide-tag">领导关怀</div> -->
                        <div class="slide-thu">
                            <img class="thu" :src="$adddom(item.thumb)">
                        </div>
                        <div class="title ellipsis2">
                            {{ item.title }}
                        </div>
                        <div class="time">{{ $timestampToTime(item.publish_at,1) }}</div>
                        <div class="divider"></div>
                        <div class="more">
                            了解更多
                            <img class="arr" src="../../../public/statics/images/arr-black.png">
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            swiper:''
        };
    },
    computed: {},
    // watch:{
    //     $route(val){
    //         this.pageChange(val.name);
    //     }
    // },
    props:['listData'],
    watch:{
        'listData':function(){
        }
    },
    created: function () {},
    mounted: function () {
    },
    updated: function () {
        let that = this
        this.$nextTick(()=>{
            if (that.swiper) {
                that.swiper.disable()
                that.swiper = ''
            }
            that.swiper = new Swiper(".swiper-profile", {
                slidesPerView: "auto",
                spaceBetween: 24,
                loop: false,
                autoplay: {
                    delay: 5000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
            });
        })
    },
    methods: {
        // 跳转更多
        toMore(){
            // console.log(this.listData.url)
            // console.log(this.listData.id)
            this.$toPath(this.listData.url,{
                active:this.listData.id
            })
        },
        /**
         * @name: 跳转详情
         * @param {*} item
         * @return {*}
         * @desc: 跳转详情
         */        
         toDetail(item){
            console.log(item)
            this.$toPath('/NewsDetail?active='+this.listData.id+'&id=' +item.id)
        },
    },
};
</script>

<style scoped>
.school-profile {
    width: 100%;
    height: 813px;
    background: url(../../../public/statics/images/SchoolProfile/icon-bg.jpg) center #002140;
}
.school-profile .container {
    padding-top: 110px;
}
.swiper {
    width: 100%;
    height: 483px;
    margin-top: 80px;
}

.swiper-slide {
    width: 330px;
    height: 433px;
    background: #f3f0ec;
    box-sizing: border-box;
    padding: 24px;
}
.swiper-slide:nth-child(odd) {
    margin-top: 50px;
}
.swiper-slide .slide-tag {
    display: inline-block;
    background-color: rgba(226, 47, 36, 1);
    overflow-wrap: break-word;
    color: rgba(243, 240, 236, 1);
    font-size: 12px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    line-height: 24px;
    padding: 0 6px;
    margin-bottom: 8px;
}
.swiper-slide .slide-thu .thu {
    display: block;
}
.swiper-slide .title {
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 17px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    text-align: left;
    line-height: 27px;
    height: 59px;
    margin-top: 15px;
}
.swiper-slide .time {
    font-size: 12px;
    font-family: PingFangSC;
    color: #002140;
    margin: 20px 0;
}
.swiper-slide .divider {
    width: 282px;
    height: 2px;
    background: #e22f24;
}
.swiper-slide .more {
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    font-family: PingFangSC;
    text-align: left;
    white-space: nowrap;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    cursor: pointer;
}
.swiper-slide .more .arr{
    width: 18px;
    height: 13px;
}
</style>
